import { useMutation } from "@apollo/client";
import React, { useState, memo, useRef } from "react";
import { Button, Input } from "reactstrap";
import { UPDATE_REGULATION, DELETE_REGULATION } from "../../../../queries";
import * as Ionicons from "react-icons/io";
import animation from "../../../../assets/utils/images/animetion_logo.gif";

const EditPdf = ({ regulationId, refetch, id }) => {
  const ref = useRef();
  const CloseIcon = Ionicons["IoMdClose"];
  const [pdf, setPdf] = useState();
  const [editRegulationMutate, { data: mutated_data, loading }] = useMutation(
    UPDATE_REGULATION,
    {
      onCompleted() {
        refetch();
      },
    }
  );

  const [deleteRegulation, { loading: loadingDelete }] = useMutation(
    DELETE_REGULATION,
    {
      onCompleted() {
        refetch();
      },
      onError(err) {
        console.log(err);
      },
    }
  );

  const onDelete = async () => {
    try {
      await deleteRegulation({
        variables: {
          orgId: id,
          orgRegulationId: regulationId,
        },
      });
    } catch (err) {
      console.error(err);
    }
  };

  const upload = async () => {
    try {
      await editRegulationMutate({
        variables: { orgId: id, regulationId: regulationId, pdf: pdf },
      });
    } catch {
      alert(
        "ファイルを確認してください。容量が大きすぎるかPDFファイル以外のファイルが選択されています。"
      );
    }
  };

  const onSelectPDF = (e) => {
    if (e.currentTarget.files !== null) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        setPdf({
          name: file.name,
          file: e.target.result,
        });
      };
      // 必須
      reader.readAsDataURL(file);
    }
  };

  const onClearPdf = (e) => {
    ref.current.value = "";
    setPdf("");
  };

  if (loading) return animation;

  return (
    <div>
      <div className="" style={{ textAlign: "left" }}>
        <div className="mt-3 mb-1">
          <input type="file" onChange={onSelectPDF} ref={ref} />
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Button size="lg" className="ema__btn__gray" onClick={upload}>
            PDF更新(5.5Mバイト以下)
          </Button>
          <Button
            size="lg"
            style={{ display: "inherit" }}
            className="ema__btn__pink mr-2"
            onClick={onDelete}
            disabled={loadingDelete}
          >
            {loadingDelete ? "loading" : " リセット"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditPdf;
